import React, { ReactNode } from "react"

import { FormikValues, useFormikContext } from "formik"

const EditOnly: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { values } = useFormikContext() as FormikValues
  return values.editing ? <>{children}</> : null
}

export default EditOnly
